import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { Router, ActivatedRoute } from '@angular/router';
import { CambiarContrasenaService } from './cambiar-contrasena.service';
import { CambiarContrasenaEntry } from 'src/app/shared/entrys/cambiar-contrasena.entry';
import { ModalCambiaContraComponent } from '../../layouts/modal-cambia-contra/modal-cambia-contra.component';

@Component({
	selector: 'app-cambiar-contrasena',
	templateUrl: './cambiar-contrasena.component.html',
	styleUrls: ['./cambiar-contrasena.component.scss']
})
export class CambiarContrasenaComponent implements OnInit, OnDestroy {
	modalGenerico: ModalGenericoModel;
	formCambiarContra: FormGroup;
	constructor(private activedRoute: ActivatedRoute,
		private router: Router,
		private cambiarContrasenaService: CambiarContrasenaService, private modalService: NgbModal, private formBuilder: FormBuilder) { }

	ngOnInit() {
		this.formCambiarContra = this.formBuilder.group({
			clave_acceso: ['', [Validators.required, ConfirmeValidators.passwordValidator]],
			clave_acceso_confirmacion: ['', Validators.required]
		}, { validator: ConfirmeValidators.childrenEqual });
	}

	public openModal() {
		const usuario = { ...this.formCambiarContra.value } as CambiarContrasenaEntry;
		usuario.key = this.activedRoute.snapshot.paramMap.get('key');
		this.cambiarContrasenaService.update(usuario).subscribe(resultado => {
			if (resultado.result) {
				const modalRef = this.modalService.open(ModalCambiaContraComponent, { centered: true });
				modalRef.result.then((resultadoModal) => {
					this.router.navigate(['/login']);
				});
			}
		});
	}

	ngOnDestroy(): void {
	}

}
